<template>
  <a-modal
    ref="createModal"
    title="编辑计划数量"
    :width="1050"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form layout="inline" :labelCol="{ style: { width: '100px' } }">
      <a-row>
        <a-col :md="10" :sm="24">
          <a-form-item label="需求数量">
            <a-input :disabled="true" v-model="planQuantity"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="10" :sm="24">
          <a-form-item label="需求交期">
            <a-input :disabled="true" v-model="demandDeliveryDate"></a-input>
          </a-form-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <span class="table-page-search-submitButtons">
            <a-button v-if="type==='1'" @click="addLine()" type="primary">新增行</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ y: 250 }"
    >
      <!-- 单位 -->
      <!-- <span slot="unitOfMeasureTitle">
        <i class="toRequired">*</i>单位
      </span>-->

      <template slot="index" slot-scope="text, record, index">
        <span>{{ index+1 }}</span>
      </template>
      <span slot="supplierTitle">
        <i class="toRequired">*</i>供应商
      </span>

      <template slot="supplierClass" slot-scope="text, record">
        <!-- <a-input v-model="record.supplier" /> -->

        <!-- <global-select
          v-if="type==='1'"
          :value.sync="record.supplierClass"
          selectType="selectSearch"
          requestApi="/mdm/mdmOrgSupplier/supplierNameList"
          :selectItem="{ value: 'realValue', label: 'realValue' }"
          searchParam="supplierName" /> -->
        <global-select
          v-if="type==='1'"
          :max-tag-count="2"
          @change="(val, list) => handleSupplierClass(val, list, record)"
          :max-tag-text-length="4"
          show-search
          :value.sync="record.supplierClass"
          selectType="select"
          :selectData="listSideOpinions"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
        />
        <span v-else>{{ record.supplierClass }}</span>
      </template>

      <template slot="supplier" slot-scope="text, record">
        <!-- <a-input v-model="record.supplier" /> -->

        <!-- <global-select
          v-if="type==='1'"
          :value.sync="record.supplier"
          selectType="selectSearch"
          :setParams="{scpSupplierCategory:record.supplierClass}"
          requestApi="/mdm/mdmOrgSupplier/supplierNameList"
          :selectItem="{ value: 'realValue', label: 'realValue' }"
          searchParam="supplierName" /> -->
        <global-select
          class="supplier"
          v-if="type==='1'"
          :max-tag-count="2"
          :max-tag-text-length="4"
          @change="(val,list)=>handleSupplier(val,list,record)"
          show-search
          :setParams="{supplierClass:record.supplierClassId}"
          :value.sync="record.supplier"
          selectType="selectSearch"
          requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
          :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
          searchParam="supplierName"
        />
        <span v-else>{{ record.supplier }}</span>
      </template>
      <!-- 分类 -->
      <span slot="planQuantityTitle">
        <i class="toRequired">*</i>计划数量
      </span>
      <template slot="planQuantity" slot-scope="text, record">
        <a-input-number @change="countPlanNum()" v-if="type==='1'" v-model="record.planQuantity" />
        <span v-else>{{ record.planQuantity }}</span>
      </template>
      <span slot="planDeliveryDateTitle">
        <i class="toRequired">*</i>计划交期
      </span>
      <template slot="planDeliveryDate" slot-scope="text, record">
        <a-date-picker :disabled-date="disabledEndDate" v-if="type==='1'" valueFormat="YYYY-MM-DD" v-model="record.planDeliveryDate" />
        <span v-else>{{ record.planDeliveryDate && $moment(record.planDeliveryDate).format('YYYY/MM/DD') }}</span>
      </template>
      <!-- 需求类型 -->
      <template slot="demandDeliveryTypeName">
        <span>{{ demandDeliveryTypeName }}</span>
      </template>

      <!-- <template slot="planDeliveryDate" slot-scope="text, record">
        <a-select v-model="record.planDeliveryDate">
          <a-select-option v-for="(item) in baseUomFlagOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
        </a-select>
      </template> -->
      <span slot="operation" slot-scope="text, record">
        <a v-if="type==='1'" @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiscpDmQuantity, apiscpDmQuantityList } from '@/api/scp/sporadic-demand/sporadic-demand'

// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    id: {
      type: String,
      default: () => {
        return ''
      }
    },
    planQuantity: {
      type: Number,
      default: () => {
        return 0
      }
    },
    demandDeliveryDate: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      listSideOpinions: [],
      demandDeliveryTypeName: '', // 需求类型，从列表带过来
      countPN: 0,
      type: '',
      orderId: '',
      planQuantityAll: '',
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
          {
           title: '序号',
          width: 50,
          dataIndex: 'index',
          align: 'center',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '供应商类别',
          width: 150,
          dataIndex: 'supplierClass',
          align: 'center',
          scopedSlots: { customRender: 'supplierClass' }
        },
        {
          // title: '供应商',
          width: 200,
          dataIndex: 'supplier',
          align: 'center',
          scopedSlots: { customRender: 'supplier', title: "supplierTitle" }
        },
        {
          //  title: '计划数量',
          width: 100,
          dataIndex: 'planQuantity',
          align: 'center',
          scopedSlots: { customRender: 'planQuantity', title: "planQuantityTitle" }
        },
        {
          //  title: '计划交期',
          width: 140,
          dataIndex: 'planDeliveryDate',
          align: 'center',
          scopedSlots: { customRender: 'planDeliveryDate', title: "planDeliveryDateTitle" }
        },
        {
           title: '下游单据号',
          width: 140,
          dataIndex: 'downstreamNo',
          align: 'center'
        },
        { title: '需求类型', width: 100, dataIndex: 'demandDeliveryTypeName', scopedSlots: { customRender: 'demandDeliveryTypeName' }, align: 'center' },
        {
          title: '操作',
          width: 80,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: []
    }
  },
  created () {
    this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'listSideOpinions')
  },
  methods: {
    handleSupplier (val, list, record) {
      const filteredItems = list.find(item => item.selectedValue === val);
      record.supplierId = filteredItems.realValue
    },
    handleSupplierClass (val, list, record) {
      record.supplierId = undefined
      record.supplier = ''; // 当变化供应商类别的时候，清空供应商
      const filteredItems = list.find(item => item.lookupValue === val);
      this.$set(record, 'supplierClassId', filteredItems.lookupCode)
    },
    getLookupList (type, arr) {
            const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
            }
            this.getLookupListData(lookupQueryParams).then().then(response => {
            this[arr] = response.rows
            if (type === 'MDM_ORG_SUPPLIER_CLASS') {
                const filteredArray = response.rows.filter(function (obj) {
                    return obj.attribute2 === "Y";
                    });
                    this[arr] = filteredArray
            }
            })
     },
    disabledEndDate (date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 将时间部分设置为零，只比较日期部分

      return date && date < today;
    },
    countPlanNum () {
      let countPNum = 0
      this.typeList.forEach(item => {
        countPNum += (item.planQuantity ? item.planQuantity : 0)
      })
      this.countPN = countPNum
    },
    getPageInfo () {
      apiscpDmQuantityList({ scpDmSporadicId: this.orderId }).then(response => {
        if (response.code === 200) {
          this.typeList = response.data
          let counter = 1; // 定义一个计数器从 1 开始
          this.typeList = this.typeList.map(item => {
            return { ...item, indexId: counter++ };
          });
          this.typeList.forEach(item => {
            const filteredItems = this.listSideOpinions.find(supplierItem => supplierItem.lookupValue === item.supplierClass);
            this.$set(item, 'supplierClassId', filteredItems.lookupCode)
          })
          if (response.data.length === 0) {
            this.addLine()
          }
          this.countPlanNum()
        } else {
          this.$message.error(response.msg)
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show (orderId, type, record) {
      this.type = type
      this.orderId = orderId
      if (this.orderId) {
        // 加载存在的数据
        this.getPageInfo()
      } else {
        this.addLine()
      }
      this.demandDeliveryTypeName = record?.demandDeliveryTypeName || '' // 需求类型，从列表带过来
      this.visible = true
    },
    addLine () {
      this.countPlanNum() // 统计总数
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        supplierClass: undefined,
        scpDmSporadicId: this.orderId,
        supplier: '',
        supplierId: '',
        planQuantity: (this.planQuantity - this.countPN),
        planDeliveryDate: '',
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    confirm () {
      if (this.type !== '1') {
        this.visible = false
        this.reset()
        this.confirmLoading = false
        return false
      }
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (this.typeList[i].planQuantity === 0) {
          this.$message.warning('计划数量不能为0')
          flag = true
          return
        }
        if (!this.typeList[i].supplier || !this.typeList[i].planQuantity || !this.typeList[i].planDeliveryDate) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        if (this.typeList[i].planQuantity < 0) {
          this.$message.warning('计划数量不能小于0')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.typeList = this.typeList.map(item => {
        const { id, ...rest } = item;
        return rest;
      });
      this.confirmLoading = true
      apiscpDmQuantity({ id: this.orderId, scpDmQuantityList: this.typeList }).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-input{
  width: 50px;
}
/deep/.ant-calendar-picker-input.ant-input{
  width: 120px;
}

/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.supplier{
  /deep/.ant-select{
    width: 200px;
  }
}
</style>
